import React from 'react';
import { Box, ButtonV2, TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

type ResendActionBarProps = Readonly<{
  selectedCount: number;
  onResend: () => void;
  onClear: () => void;
  disabled?: boolean;
}>;

/**
 * Appears once at least one row is selected, per MSG-160 requirement #2 — the checkbox column is
 * always visible, and this is what shows up in response to a selection.
 *
 * Laid out so further bulk actions (export the selection, etc.) can join the button group later
 * without restructuring.
 */
export const ResendActionBar: React.FC<ResendActionBarProps> = ({ selectedCount, onResend, onClear, disabled }) => {
  const { tq } = useTranslation('messagesV2ServiceCenter');

  if (selectedCount === 0) {
    return null;
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap="12px"
      padding="10px 16px"
      borderRadius={8}
      background="rgb(238,235,255)"
      border="1px solid rgb(214,208,255)"
    >
      <TextV2
        typographyVariant="label3"
        fontWeight={600}
      >
        {selectedCount === 1 ? tq`1 message selected` : tq`${selectedCount.toString()} messages selected`}
      </TextV2>

      <Box
        display="flex"
        alignItems="center"
        gap="8px"
      >
        <ButtonV2
          type="button"
          size="sm"
          variant="ghost"
          onClick={onClear}
          disabled={disabled}
        >
          {tq`Clear`}
        </ButtonV2>
        <ButtonV2
          type="button"
          size="sm"
          variant="solid"
          onClick={onResend}
          disabled={disabled}
        >
          {tq`Resend`}
        </ButtonV2>
      </Box>
    </Box>
  );
};
